import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import CurrencyInput from "@/components/ui/inputs/currency-input.vue";
import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { TransactionsValidation } from "acquaint-api/validation/TransactionsValidation";


export default /*#__PURE__*/_defineComponent({
  __name: 'statement-notes-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The title of modal.
   * @type {String}
   * @default: "Statement Notes"
   */
  title: {
    type: String,
    default: "Statement Notes",
  },
  /**
   * The label of input box.
   * @type {String}
   * @default: "This transaction will be transferred to the landlord's account. Please enter statement notes for the landlord."
   */
  label: {
    type: String,
    default:
      "This transaction will be transferred to the landlord's account. Please enter statement notes for the landlord.",
  },
  /**
   * Whether the value type is number.
   * @type {Boolean}
   * @default: false
   */
  isNumber: {
    type: Boolean,
    default: false,
  },
  /**
   * The value of input box.
   * @type {String}
   * @default: ""
   */
  fieldValue: {
    type: String,
    default: "",
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when clicks Save.
   * Emits the statement notes.
   * @property {string} Statement
   */
  "saveClick",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const statementNotes = ref("");
const amount = ref(0);

watch([() => props.fieldValue, () => props.isNumber], () => {
  if (props.isNumber) {
    amount.value = Number(props.fieldValue);
  } else {
    statementNotes.value = props.fieldValue;
  }
});

const onSaveClick = () => {
  const emitVal = props.isNumber ? amount.value : statementNotes.value;
  emit("saveClick", emitVal);
  showModal.value = false;
};

const onCancelClick = () => {
  showModal.value = false;
};
const modalClosed = () => {
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
    title: __props.title,
    height: '230',
    width: _unref(ModalWidth).XSmall,
    onModalClosed: modalClosed
  }, {
    content: _withCtx(() => [
      (__props.isNumber)
        ? (_openBlock(), _createBlock(CurrencyInput, {
            key: 0,
            modelValue: amount.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((amount).value = $event)),
            label: __props.label,
            minValue: 0,
            maxValue: 999999999,
            "read-only": false
          }, null, 8, ["modelValue", "label"]))
        : (_openBlock(), _createBlock(AcquaintTextbox, {
            key: 1,
            modelValue: statementNotes.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((statementNotes).value = $event)),
            label: __props.label,
            fieldValidation: _unref(TransactionsValidation).StatementNotes
          }, null, 8, ["modelValue", "label", "fieldValidation"]))
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          disabled: false,
          text: 'Save',
          onClick: () => {
            onSaveClick();
          },
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "width"]))
}
}

})